import React, { useState, useEffect } from "react";
import { Dropdown, Row, Nav, Tab } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import ForgetPasswordModal from "../../components/superAdmin/ForgetPasswordModal";
import { IMAGES } from "../../constant/theme";
import {
  downloadAllCoaches,
  getCoach,
} from "../../../services/academicService";
import CoachAttendenceQrModal from "../../components/qr/CoachAttendenceQrModal";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const theadData = [
  { heading: "S.No", sortingVale: "sno" },
  { heading: "Name", sortingVale: "name" },
  { heading: "Age", sortingVale: "age" },
  { heading: "Email", sortingVale: "email" },
  { heading: "Phone", sortingVale: "phone" },
  { heading: "Experience", sortingVale: "experience" },
  { heading: "Qualification", sortingVale: "qualification" },
  { heading: "Skill", sortingVale: "skill" },
  { heading: "Action", sortingVale: "action" },
];

const svg1 = (
  <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24"></rect>
      <circle fill="#000000" cx="5" cy="12" r="2"></circle>
      <circle fill="#000000" cx="12" cy="12" r="2"></circle>
      <circle fill="#000000" cx="19" cy="12" r="2"></circle>
    </g>
  </svg>
);

const AllCoaches = () => {
  const [forgetModal, setForgetModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);

  // pagination & search
  const [page, setPage] = useState(0); // 0-based
  const [size, setSize] = useState(10); // page size
  const [search, setSearch] = useState(""); // search text
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [qrCodeModal, setQrCodeModal] = useState(false);

  // sorting icon state (you can later connect this with API sort params)
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });

  // ---- API CALL WITH page, size, search ----
  async function fetchUserData({ page, size, search }) {
    setLoading(true);
    try {
      const res = await getCoach(page, size, search);
      setUserData(res?.content || []);
      setTotalElements(res?.totalElements || 0);
      setTotalPages(res?.totalPages || 0);
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  }

  // initial & whenever page/size/search changes
  useEffect(() => {
    fetchUserData({ page, size, search });
  }, [page, size, search]);

  // ---- client sorting (optional; if you want server-side sort, pass sort to API instead) ----
  function SotingData(name) {
    const sortedPeople = [...userData];
    switch (name) {
      case "name":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? a.name.localeCompare(b.name)
            : b.name.localeCompare(a.name)
        );
        break;

      case "email":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? a.name.localeCompare(b.name)
            : b.name.localeCompare(a.name)
        );
        break;

      case "landLine":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a.landLine || "").localeCompare(b.landLine || "")
            : (b.landLine || "").localeCompare(a.landLine || "")
        );
        break;

      case "phone":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a.phone || "").localeCompare(b.phone || "")
            : (b.phone || "").localeCompare(a.phone || "")
        );
        break;

      default:
        break;
    }
    setUserData(sortedPeople);
  }

  // ---- Search handler ----
  function handleSearchChange(e) {
    const value = e.target.value;
    setSearch(value);
    setPage(0); // reset to first page on search
  }

  // ---- Pagination helpers ----
  const currentStart = totalElements === 0 ? 0 : page * size + 1;

  const downloadExcel = async () => {
    try {
      const res = await downloadAllCoaches(search);

      const formattedData = res?.content?.map((data, index) => ({
        "S.No": index + 1,
        Name: data.name,
        Age: data.age,
        Email: data.email,
        "Contact Phone": data.contactPhone,
        Experience: data.experience,
        Qualification: data.qualification,
        "Coach Skill": data.coachSkill,
      }));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Members");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const file = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(file, "AllCoaches.xlsx");
    } catch (error) {
      console.error("Excel download failed:", error);
    }
  };

  return (
    <>
      <PageTitle activeMenu={"All Coaches"} motherMenu={"Coaches"} />
      <Row>
        <Tab.Container defaultActiveKey={"List"}>
          <div className="col-lg-12">
            <Nav as="ul" className="nav nav-pills mb-3">
              <Nav.Item as="li">
                <Nav.Link eventKey="List" className="me-1">
                  List View
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li">
                <Nav.Link eventKey="Grid">Grid View</Nav.Link>
              </Nav.Item>
            </Nav>
          </div>

          <div className="col-lg-12">
            <Tab.Content className="row tab-content">
              {/* LIST VIEW */}
              <Tab.Pane eventKey="List" className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">All Coach List</h4>
                    <div>
                      <Link to={"/admin/add-coach"} className="btn btn-primary">
                        + Add New
                      </Link>
                      <button
                        className="btn btn-primary m-2"
                        onClick={() => downloadExcel()}
                      >
                        Download
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div className="dataTables_wrapper no-footer">
                        <div className="justify-content-between d-sm-flex">
                          {/* PAGE SIZE DROPDOWN */}
                          <div className="dataTables_length">
                            <label className="d-flex align-items-center">
                              Show
                              <Dropdown className="search-drop ms-2 me-2">
                                <Dropdown.Toggle
                                  as="div"
                                  className="search-drop-btn"
                                >
                                  {size}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  {[10, 20, 30].map((val) => (
                                    <Dropdown.Item
                                      key={val}
                                      onClick={() => {
                                        setSize(val);
                                        setPage(0);
                                      }}
                                    >
                                      {val}
                                    </Dropdown.Item>
                                  ))}
                                </Dropdown.Menu>
                              </Dropdown>
                              entries
                            </label>
                          </div>

                          {/* SEARCH */}
                          <div className="dataTables_filter">
                            <label>
                              Search :{" "}
                              <input
                                type="search"
                                className=""
                                placeholder=""
                                value={search}
                                onChange={handleSearchChange}
                              />
                            </label>
                          </div>
                        </div>

                        {/* TABLE */}
                        <table
                          id="example4"
                          className="display dataTable no-footer w-100"
                        >
                          <thead>
                            <tr>
                              {theadData.map((item, ind) => (
                                <th
                                  key={ind}
                                  onClick={() => {
                                    if (item.sortingVale === "action") return;
                                    SotingData(item.sortingVale);
                                    setIconDate((prevState) => ({
                                      complete: !prevState.complete,
                                      ind: ind,
                                    }));
                                  }}
                                  style={
                                    item.sortingVale !== "action"
                                      ? { cursor: "pointer" }
                                      : {}
                                  }
                                >
                                  {item.heading}
                                  {item.sortingVale !== "action" && (
                                    <span>
                                      {ind !== iconData.ind && (
                                        <i
                                          className="fa fa-sort ms-2 fs-12"
                                          style={{ opacity: "0.3" }}
                                        />
                                      )}
                                      {ind === iconData.ind &&
                                        (iconData.complete ? (
                                          <i
                                            className="fa fa-arrow-down ms-2 fs-12"
                                            style={{ opacity: "0.7" }}
                                          />
                                        ) : (
                                          <i
                                            className="fa fa-arrow-up ms-2 fs-12"
                                            style={{ opacity: "0.7" }}
                                          />
                                        ))}
                                    </span>
                                  )}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {!loading &&
                              userData.map((data, ind) => (
                                <tr key={ind}>
                                  <td>{page * size + ind + 1}</td>
                                  <td>{data.name}</td>
                                  <td>{data.age}</td>
                                  <td>{data.email}</td>
                                  <td>{data.contactPhone}</td>
                                  <td>{data.experience}</td>
                                  <td>{data.qualification}</td>
                                  <td>{data.coachSkill}</td>
                                  <td>
                                    <div className="d-flex align-items-center gap-2">
                                      <Link
                                        to="/admin/add-coach"
                                        state={{ user: data, mode: "edit" }}
                                        className="btn btn-s sharp btn-primary"
                                      >
                                        <i className="fa fa-pencil" />
                                      </Link>

                                      <Dropdown>
                                        <Dropdown.Toggle
                                          variant="success"
                                          className="light sharp i-false"
                                        >
                                          {svg1}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                          <Dropdown.Item
                                            as={Link}
                                            to="/admin/about-coach"
                                            state={{ user: data }}
                                          >
                                            View
                                          </Dropdown.Item>
                                          {/* <Dropdown.Item
                                            onClick={() => {
                                              setSelectedUser(data);
                                              setForgetModal(true);
                                            }}
                                          >
                                            Change Password
                                          </Dropdown.Item> */}
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                  </td>
                                </tr>
                              ))}

                            {loading && (
                              <tr>
                                <td colSpan={5} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            )}

                            {!loading && userData.length === 0 && (
                              <tr>
                                <td colSpan={5} className="text-center">
                                  No data found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                        {/* PAGINATION FOOTER */}
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                          <div className="dataTables_info">
                            <span>
                              Page{" "}
                              <strong>
                                {page + 1} of {totalPages}
                              </strong>
                            </span>
                          </div>
                          <div className="dataTables_paginate paging_simple_numbers">
                            <Link
                              className={`paginate_button previous ${
                                page === 0 ? "disabled" : ""
                              }`}
                              to="#"
                              onClick={(e) => {
                                e.preventDefault();
                                if (page > 0) setPage(page - 1);
                              }}
                            >
                              Previous
                            </Link>

                            <Link
                              className={`paginate_button next ${
                                page + 1 >= totalPages ? "disabled" : ""
                              }`}
                              to="#"
                              onClick={(e) => {
                                e.preventDefault();
                                if (page + 1 < totalPages) setPage(page + 1);
                              }}
                            >
                              Next
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>

              {/* GRID VIEW */}
              <Tab.Pane eventKey="Grid" className="col-lg-12">
                <div className="row">
                  {userData?.map((item, ind) => (
                    <div
                      className="col-lg-4 col-md-6 col-sm-6 col-12"
                      key={ind}
                    >
                      <div className="card card-profile">
                        <div className="card-header justify-content-end pb-0 border-0">
                          <Dropdown>
                            <Dropdown.Toggle
                              as="button"
                              className="btn btn-link i-false"
                              type="button"
                            >
                              <span className="dropdown-dots fs--1"></span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              align="end"
                              className="dropdown-menu dropdown-menu-right border py-0"
                            >
                              <div className="py-2">
                                <Link
                                  to="/super-admin/add-user"
                                  state={{ user: item, mode: "edit" }}
                                  className="dropdown-item"
                                >
                                  Edit
                                </Link>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="card-body pt-2">
                          <div className="text-center">
                            <div className="profile-photo">
                              <img
                                src={IMAGES?.smallpic2}
                                width="100"
                                className="img-fluid rounded-circle"
                                alt=""
                              />
                            </div>
                            <h3 className="mt-4 mb-1">{item?.name}</h3>

                            <ul className="list-group mb-3 list-group-flush">
                              <li className="list-group-item px-0 d-flex justify-content-between">
                                <span className="mb-0">Email:</span>
                                <span className="mb-0">{item?.email}</span>
                              </li>
                              <li className="list-group-item px-0 d-flex justify-content-between">
                                <span className="mb-0">Phone:</span>
                                <span>{item?.contactPhone}</span>
                              </li>
                              <li className="list-group-item px-0 d-flex justify-content-between">
                                <span className="mb-0">Skill:</span>
                                <span>{item?.coachSkill}</span>
                              </li>
                              <li className="list-group-item px-0 d-flex justify-content-between">
                                <span className="mb-0">Experience:</span>
                                <span>{item?.experience} Years</span>
                              </li>
                            </ul>

                            <Link
                              to="/admin/about-coach"
                              state={{ user: item }}
                              className="btn btn-outline-primary btn-rounded mt-3 px-4"
                            >
                              Read More
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  {loading && (
                    <div className="col-12 text-center my-3">Loading...</div>
                  )}
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </Row>

      <ForgetPasswordModal
        show={forgetModal}
        onClose={() => setForgetModal(false)}
        userData={selectedUser}
      />

      <CoachAttendenceQrModal
        show={qrCodeModal}
        onClose={() => setQrCodeModal(false)}
        url="test-url-coach-attendence"
      />
    </>
  );
};

export default AllCoaches;
